import { ORDER_STATUSES, type OrderStatus } from '@cult/domain';
import { Tag } from 'antd';

const STATUS_COLOR: Record<OrderStatus, string> = {
  [ORDER_STATUSES.PENDING]: 'blue',
  [ORDER_STATUSES.IN_PROGRESS]: 'gold',
  [ORDER_STATUSES.DONE]: 'success',
  [ORDER_STATUSES.REJECTED]: 'error',
};

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  [ORDER_STATUSES.PENDING]: 'Pending',
  [ORDER_STATUSES.IN_PROGRESS]: 'In progress',
  [ORDER_STATUSES.DONE]: 'Done',
  [ORDER_STATUSES.REJECTED]: 'Rejected',
};

type Props = {
  status: OrderStatus;
};

export const OrderStatusTag = ({ status }: Props) => (
  <Tag color={STATUS_COLOR[status]} style={{ marginRight: 0, padding: '2px 10px' }}>
    {ORDER_STATUS_LABEL[status]}
  </Tag>
);
